import { userData } from "../../js/api/profile.js";
import IframeModal from "../components/IframeModal.js";
import {
  getCurrentBalance,
  updatecasinocurrency,
} from "../../js/api/balance.js";
import { _t } from "../../services/TranslationService.js";
import {
  getGameList,
  getGamesCategories,
  launchGame,
} from "../../js/api/vegascasino.js";
import { isVegasSupportedDomain } from "../../js/constants/global-variables.js";

// const gameCategories = [
//     "playngo",
//     "egt",
//     "isoftbet",
//     "gamomat",
//     "playtech",
//     "amatic",
//     "aristocrat",
//     "casino-technology",
//     "greentube",
//     "igrosoft",
//     "netent",
//     "novomatic",
//     "pragmatic",
//     "skywind",
//     "mainama",
//     "ka-gaming",
//     "wazdan",
//     "vision",
//     "keno",
//     "card",
//     "roulette",
//     "arcade",
//     "playgt",
//     "cq9",
//     "gdgames",
//     "betsoft",
//     "netgame",
//     "new",
//     "jackpot",
//     "evolution",
//     "slots",
//     "igtech",
//     "merkur"
// ];

const categoryGroups = [
  {
    id: 'vip_game',
    name: 'VIP Games',
    allowedCategories: ['pragmatic', 'netgame', 'wazdan', 'netent', 'playtech', 'playngo', 'isoftbet', 'cq9', 'betsoft', 'ka-gaming']
  },
  {
    id: 'admiral_game',
    name: 'Admiral Games',
    allowedCategories: ['novomatic', 'gamomat', 'vision', 'igrosoft', 'aristocrat']
  },
  {
    id: 'virtual_game',
    name: 'Virtual Games',
    allowedCategories: ['card', 'roulette']
  },
  {
    id: 'keno',
    name: 'Keno',
    allowedCategories: ['keno']
  },
  {
    id: 'vegas_games',
    name: 'Vegas Games',
    allowedCategories: [
      "greentube",
      "amatic",
      "egt",
      "merkur",
      "casino-technology",
      "skywind",
      "mainama",
      "arcade",
      "playgt",
      "gdgames",
      "new",
      "jackpot",
      "evolution",
      "slots",
      "igtech",
    ]
  }
];

// Vegas Casino Games
const Vegas = {
  render: async () => {
    if (isVegasSupportedDomain.indexOf(location.host) === -1) {
      return `
        <h2 style="color:white;text-align:center;margin-top:50px;">Vegas Casino is not supported on this domain.</h2>
        <div style="text-align:center;margin-top:20px;">
          <a href="#/" style="color:white;">Go to homepage</a>
        </div>
      `;
    }

    const queryString = window.location.hash.split('?')[1];
    let categoryParam = queryString ? new URLSearchParams(queryString).get('category') : null;
    let category = null;
    if (!categoryParam) {
      categoryParam = 'vegas_games';
    }
    
    if (categoryParam) {
      category = categoryGroups.find(group => group.id === categoryParam);
    }




    const gameCategories = await getGamesCategories();
    const gameList = await getGameList();

    let groups = gameCategories[0].name;
    if (!groups || (groups && !Array.isArray(groups))) {
      return "";
    }

    let baseUrlIcons = "https://vegasbets.site";
    let groupView = `
      <div class="searchGameHolder">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5s4.
    5 2.01 4.5 4.5S11.99 14 9.5 14z"/></svg>
          <input type="search" id="searchGameInput" placeholder="${_t(
            "Search game"
          )}..." />
      </div>
    `;
    let groupBtnView = ``;

    groupBtnView += `<div class="groupFamilyBtn active" data-btn-target="all" data-sortindex="1" style="order: 1"><span class="">${_t(
      "All games"
    )}</span></div>`;
    
    const allowedCategories = category?.allowedCategories || [];
    groups.sort((a, b) => {
      const aAllowedIndex = allowedCategories.indexOf(a.href);
      const bAllowedIndex = allowedCategories.indexOf(b.href);

      const aOrder =
        aAllowedIndex >= 0
          ? aAllowedIndex + 2
          : a.position + allowedCategories.length + 2;
      const bOrder =
        bAllowedIndex >= 0
          ? bAllowedIndex + 2
          : b.position + allowedCategories.length + 2;

      return aOrder - bOrder;
    });

    let groupIndex = 0;
    for (const group of groups) {
      if (allowedCategories.length > 0 && !allowedCategories.includes(group.href)) {
        continue;
      }
      groupIndex++;

      let gamesItemView = ``;
      groupBtnView += `
        <div class="groupFamilyBtn" data-btn-target="${group.href}" data-sortindex="${groupIndex}" style="order: ${groupIndex}"><span class="">${group.title}</span></div>
      `;

      let gameIndex = groupIndex;
      for (const game of gameList.filter(
        (g) => g.category_name === group.href
      )) {
        gamesItemView += `
          <div class="game animation-element" game="${game.id}" group="${game.category_name}" data-sortindex="${gameIndex}" style="order: ${gameIndex}">
            <img src="${baseUrlIcons}${game.image_url}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" lazy style="min-height: 75px"/>
            <span>${game.title}</span>
          </div>
        `;
        gameIndex++;
      }

      groupView += `
        ${gamesItemView}
      `;
    }

    // $.each(group, function(i, item){

    //   let gamesItemView = ``;
    //   groupBtnView += `
    //     <div class="groupFamilyBtn" data-btn-target="${i.replaceAll(' ', '')}" data-sortindex="${index}" style="order: ${index}"><span class="">${i}</span></div>
    //   `;
    // for (const key in item) {

    //   if (Object.hasOwnProperty.call(item, key)) {
    //     const element = item[key];

    //     gamesItemView += `
    //       <div class="game animation-element" game="${element.ID}" group="${element.Platform.replaceAll(' ', '')}" style="display: none;">
    //         <img src="${baseUrlIcons}${element.GameIconUrl}" loading="lazy" onerror="javascript:this.src='./img/games_icons/duser.jpg'" />
    //         <span>${element.Name}</span>
    //       </div>
    //     `;
    //   }
    // }
    // groupView += `
    //   ${gamesItemView}
    // `;
    // })

    let view = /*html*/ `
         <div class="modalHelperHolder">
            <div class="modalHelperPosition">
                <span>Zgjedh monedhen per casino</span>
                <select id="coinSelectorSelect">
                </select>
                <a class="submitBtn modalHandler" id="submitCoinSelected">Vazhdo</a>
            </div>
        </div>

        <h1 class="deluxeTitle" >Welcome To ${category ? category.name : 'Vegas Games'}</h1>

          
       <div class="slotsCatHolder">
            <div class="slotsCatHelper" id="slotsCatBtn" style="display: flex;">
              ${groupBtnView}
            </div>
       </div>
       <div class="slotsMainWrapper deluxeView">
          <div id="main" style="text-align: left;">
              ${groupView}
          </div>
       </div>
       `;
    return view;
  },
  after_render: async () => {
    const userDataBody = await userData(localStorage.getItem("user_id"));
    if (!$("body").hasClass("bg-black")) {
      $("body").addClass("bg-black");
    }

    $("body").click(function (e) {
      if (!$(e.target).is(".modalHelperPosition,.modalHelperPosition *")) {
        $(".modalHelperHolder").removeClass("active");
      }
    });

    setCurrentBalanceForSlots();

    $("body .landingMashineBox").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      centerMode: true,
      variableWidth: false,
      dots: false,
      prevArrow: false,
      nextArrow: false,
    });

    let catLengthWidth = 0;
    $(".groupFamilyBtn ").each(function (e) {
      catLengthWidth += $(this).outerWidth();
    });
    $("body .slotsCatHelper").css({
      width: catLengthWidth + 3 + "px",
    });

    // $("#main").html(groupContent);

    // Filter games by category
    $("body").off("click", ".groupFamilyBtn");
    $("body").on("click", ".groupFamilyBtn", function (e) {
      let eventTarget = $(e.currentTarget).attr("data-btn-target");
      $("body .groupFamilyBtn").removeClass("active");
      $(e.currentTarget).addClass("active");
      if (eventTarget === "all") {
        $(".game").show();
      } else {
        $(".game[group='" + eventTarget + "']").show();
        $(".game")
          .not("[group='" + eventTarget + "']")
          .hide();
      }
    });

    // Search games
    $("#searchGameInput")
      .unbind()
      .on("keyup", function (e) {
        let value = $(e.currentTarget).val().toLowerCase();
        $("body .groupFamilyBtn").removeClass("active");
        $("body .groupFamilyBtn[data-btn-target='all']").addClass("active");
        if (!value) {
          $(".game").show();
          return;
        }
        $(".game").filter(function () {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
        });
      });
    $("#searchGameInput").on("search", function (e) {
      let value = $(e.currentTarget).val().toLowerCase();
      if (!value) {
        $(".game").show();
        return;
      }
    });

    $("body").on("click", "#submitCoinSelected", async function (e) {
      const res = await updatecasinocurrency($("#coinSelectorSelect").val());
      alert("Monedha u vendos, vazhdoni te luani!!");
      callSliderEvent();
    });

    $(".game").off("click");
    $(".game").on("click", async function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }

      $(e.currentTarget).addClass("clicked");
      const gameID = parseInt($(e.currentTarget).attr("game"), 10);
      const game = await launchGame(gameID);
      console.log(game);

      if (game && game.success === true && game.url) {
        setTimeout(async function () {
          IframeModal.loadIframe(game.url);
          IframeModal.show("VEGAS CASINO");
          $(e.currentTarget).removeClass("clicked");
        }, 1200);
      } else {
        alert("Game is currently unavailable. Please try again later.");
        $(e.currentTarget).removeClass("clicked");
        return;
      }
    });
  },
};

async function setCurrentBalanceForSlots() {
  var currentBalanceResult = await getCurrentBalance();

  if (currentBalanceResult.casino_currency) return;

  var coins = [];

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });
      }
    }
  }

  renderCoins(coins);
  callSliderEvent();
}

function getCasinoCurrencyBalance(balance) {
  if (!balance || (balance && !balance.casino_currency)) {
    return null;
  }

  const casinoCurrencyId = balance.casino_currency;

  const currencyCode = (id) => {
    switch (id) {
      case "1":
        return "EUR";
      case "2":
        return "ALL";
      case "3":
        return "USD";
      default:
        return null;
    }
  };

  if (balance && balance.total_coins) {
    if (balance.total_coins.includes("|")) {
      const allCoins = balance.total_coins.split("|");

      for (const coinString of allCoins) {
        const [idAndName, amount] = coinString.split(";");
        const [id, currencyName] = idAndName.split(".");

        if (id === casinoCurrencyId) {
          return {
            id: id,
            currency: currencyName,
            code: currencyCode(id),
            amount: parseFloat(amount),
          };
        }
      }
    }
  }

  return null;
}

async function renderCoins(coins) {
  coins.forEach((element) => {
    $("#coinSelectorSelect").append(`<option value="${element.id}"> 
       ${element.currency}   
 </option>`);
  });
}

function callSliderEvent() {
  if ($("body .modalHelperHolder").hasClass("active")) {
    $("body .modalHelperHolder").removeClass("active");
  } else {
    $("body .modalHelperHolder").addClass("active");
  }
}

export default Vegas;
